module.exports = __webpack_public_path__ + "img/1418810887.b549621d.jpg";